import moment from 'moment'
import axios from 'axios'
import md5 from 'js-md5'
import { getStore, setStore, removeStore } from './session'
import { PROCESS_ENV, SHARE_URL, BASE_HREF } from '@/config/index'
import { checkLogin } from '@/api/login'
import { WxJsSignatureInfo } from '@/api/wechatConfig'
const wx = require('weixin-js-sdk')

const SH_NEWHAND_GUIDE = 'SHNEWHANDGUIDE'
const NEWCOMER = 'NEWCOMER'
const ISZEROHIDESCORE = 'ISZEROHIDESCORE'

export default {
  getUrlKey(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    } else {
      return null
    }
  },
  isYesOrToday(val) {
    let yesterday = moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD')
    let today = moment().format('YYYY-MM-DD')
    if (moment(moment(val).format('YYYY-MM-DD')).isSame(today)) {
      return '今天'
    } else if (moment(moment(val).format('YYYY-MM-DD')).isSame(yesterday)) {
      return '昨天'
    } else {
      return false
    }
  },
  // 深拷贝对象
  deepCopy(obj) {
    let copyObj = JSON.parse(JSON.stringify(obj))
    return copyObj
  },
  isIOS() {
    let isIphone = navigator.userAgent.includes('iPhone')
    let isIpad = navigator.userAgent.includes('iPad')
    return isIphone || isIpad
  },
  // 签名
  signatureInfoApi(fn) {
    return new Promise((resolve, reject) => {
      let htmlArray = window.location.href.split('#')
      let params = {
        url: htmlArray[0]
      }
      WxJsSignatureInfo(params)
        .then((res) => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: 'wxaa3a999db5d744c6', // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'chooseWXPay'], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
          })
          wx.ready(function() {
            resolve()
          })
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 分享
  shareApi(titleShort, wAPPicUrl, shareLink) {
    if (PROCESS_ENV === 'production') {
      // 分享
      wx.ready(function() {
        // 需在用户可能点击分享按钮前就先调用
        let linkUrl = `${SHARE_URL}/?redirectRouter=${shareLink}#`
        wx.onMenuShareAppMessage({
          title: titleShort, // 分享标题
          desc: '搜货精选', // 分享描述
          link: linkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: wAPPicUrl, // 分享图标
          success: function(res) {},
          fail: function(res) {},
          complete: function(res) {}
        })
      })
    }
  },
  // 隐藏菜单
  hideMenuItems() {
    wx.ready(function() {
      wx.hideMenuItems({
        menuList: ['menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:share:appMessage']
      })
    })
  },
  showMenuItems() {
    wx.ready(function() {
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage']
      })
    })
  },
  // 发起一个微信支付请求
  chooseWXPay(config) {
    return new Promise((resolve) => {
      wx.ready(function() {
        wx.chooseWXPay({
          timestamp: config.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: config.nonceStr, // 支付签名随机串，不长于 32 位
          package: config.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: config.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: config.paySign, // 支付签名
          complete: function() {
            // 可能出现未同步的情况
            resolve()
          }
        })
      })
    })
  },
  // 调试模式--记入日志接口
  logError(error) {
    axios.post('https://jenkinsmanagement-test.leqilucky.com/errorlog', {
      error: error
    })
  },
  // 调试模式--登录
  debugLogin(vm, Indicator) {
    let baseHrefRandom = '?time=' + new Date().getTime()
    Indicator.open({
      text: '加载中',
      spinnerType: 'triple-bounce'
    })
    let sessionId = vm.$store.getters.sessionId
    let redirectRouter = this.getUrlKey('redirectRouter')
    let trackEvent = this.getUrlKey('trackEvent')
    if (trackEvent) {
      if (trackEvent === 'soho2018') {
        window._hmt.push(['_trackEvent', 'ad', 'ad-entry', 'tencent'])
      }
    }
    // sessionId存在表示已登陆过，页面被重新刷新
    if (sessionId) {
      this.setErrorLog({ errType: 'login', position: 'check login', userToken: sessionId })
      checkLogin().then((res) => {
        if (res.isLogin) {
          vm.loginComplete = true
          setTimeout(Indicator.close, 300)
          vm.urlRedirect(redirectRouter)
        } else {
          vm.loginOut().then(() => {
            this.setErrorLog({ errType: 'login', position: 'login out', userToken: sessionId })
            window.location.href = BASE_HREF + baseHrefRandom
          })
        }
      })
    } else {
      let code = this.getUrlKey('code')
      let getWechatCode = this.getUrlKey('getWechatCode')
      // code存在时表示微信进入，否则返回微信授权链接
      if (code) {
        if (getWechatCode === 'soho2018') return
        this.setErrorLog({ errType: 'login', position: 'code login' })
        // 登陆api
        vm.loginMode(code)
          .then(() => {
            vm.loginComplete = true
            vm.urlRedirect(redirectRouter)
          })
          .catch((err) => {
            if (PROCESS_ENV === 'production') {
              window.location.href = BASE_HREF + baseHrefRandom
            } else {
              vm.failComplete = true
              // console.error('提示：', err)
            }
            this.setErrorLog({ errType: 'login', errMsg: err, position: 'login error', isCodeErr: true })
          })
          .then(() => {
            Indicator.close()
          })
      } else {
        this.setErrorLog({ errType: 'login', position: 'no code' })
        if (redirectRouter) {
          this.setErrorLog({ errType: 'share', position: 'share in' })
          // 从分享页进来时，微信会给分享的链接添加一些后缀，所以进来时，需要将后缀截掉，否则无法跳转到相应的页面
          let link = `${SHARE_URL}/?${window.location.href.split('?')[1].split('&')[0]}`
          let encodeLink = encodeURIComponent(link)
          window.location.href =
            'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa3a999db5d744c6&redirect_uri=' +
            encodeLink +
            '&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect' +
            baseHrefRandom
        } else {
          window.location.href = BASE_HREF + baseHrefRandom
        }
      }
    }
  },
  // 调试模式--设置log
  setErrorLog({
    errType = '', // 错误类型
    errMsg = '无', // 错误信息
    position = '', // 错误位置
    userToken = '无', // 发生错误的用户
    isCodeErr = false // 是否为代码出错（catch）
  } = {}) {
    try {
      let urlDebugKey = this.getUrlKey('debugKey')
      let UA = window.navigator.userAgent.toLowerCase()
      let platform = 'PC'
      if (/iphone|ipad|ipod|ios/.test(UA)) platform = 'IOS'
      else if (UA.indexOf('android') > 0) platform = 'Andriod'
      let errObj = {
        errType: errType,
        errMsg: errMsg,
        platform: platform,
        position: position,
        userToken: userToken,
        isCodeErr: isCodeErr
      }
      let errLogStr = JSON.stringify(errObj)
      if (urlDebugKey) this.logError(errLogStr)
      return errLogStr
    } catch (error) {}
  },
  // 设置新手引导是否展示
  setNewGuideSession({ isNewHand = false, stepOne = false, stepThree = false, questionOne = false, questionTwo = false, questionThree = false, orderSubmit = false }) {
    let showObj = {
      isNewHand: isNewHand,
      stepOne: stepOne,
      stepThree: stepThree,
      questionOne: questionOne,
      questionTwo: questionTwo,
      questionThree: questionThree,
      orderSubmit: orderSubmit
    }
    setStore(SH_NEWHAND_GUIDE, showObj)
  },
  // 获取新手引导对应的页面是否显示
  getNewGuideSession(key, isAll) {
    let obj = getStore(SH_NEWHAND_GUIDE) || {}
    if (key) return obj[key]
    else return obj
  },
  MD5Hex(val) {
    if (!val) return
    return md5(String(val))
  },
  // 设置是否是新人storage
  setNewcomerStorage(val) {
    try {
      if (val) {
        // add
        val = true
        setStore(this.MD5Hex(NEWCOMER), this.MD5Hex(val))
      } else {
        // remove
        removeStore(this.MD5Hex(NEWCOMER))
      }
    } catch (error) {
      // console.log('Newcomer error: ', error)
    }
  },
  getNewcomerStorage() {
    let val = getStore(this.MD5Hex(NEWCOMER))
    if (val && val === this.MD5Hex(true)) {
      return true
    } else {
      return false
    }
  },
  // 设置是否是新人storage
  setIsZeroHideScoreStorage(val) {
    try {
      if (val) {
        // add
        val = true
        setStore(this.MD5Hex(ISZEROHIDESCORE), this.MD5Hex(val))
      } else {
        // remove
        removeStore(this.MD5Hex(ISZEROHIDESCORE))
      }
    } catch (error) {
      // console.log('ISZEROHIDESCORE error: ', error)
    }
  },
  getIsZeroHideScoreStorage() {
    let val = getStore(this.MD5Hex(ISZEROHIDESCORE))
    if (val && val === this.MD5Hex(true)) {
      return true
    } else {
      return false
    }
  }
}
